/**
 * A filter value counts as "active" once the user has actually set it.
 * Uses a truthiness check, so '', null, undefined, 0, and false are all
 * treated as inactive (cleared). Shared by every FilterPanel host so the
 * Clear button's enabled state is computed the same way everywhere.
 *
 * Note: callers must not pass 0 or false as a meaningful active filter value —
 * those will be incorrectly treated as inactive. Use '' or null as the
 * cleared/unset state for all filter fields.
 */
export const hasActiveFilters = (values) => values.some(Boolean);
